import { loadStripe } from '@stripe/stripe-js';
import dotenv from 'dotenv';

const stripePromise = loadStripe('pk_live_51PSjZhP9fsfy64cWUHg6964PQ7Jv7ddnAP33IcCzLn8YrGNMoFEqTTkAiXnoocsIzVlOsC1Xc15EDAaaFGW8tDQr00iWQdfwpx');
// const stripePromise = loadStripe('pk_test_51PSjZhP9fsfy64cWMlGGNVuufcfibt0eIk0eHW8s8XzG5b0H0TU1yasLDsdgxjMAbORN5mXxe8QdLKJTNuu4GVdL00UtUBTBSh');

export default stripePromise;
